import React from 'react';

import ImageSelection from '../../../form-components/image-selection';

export default ({
  // Data values
  images,
  setImages,
  requiresMainImage,
  mainImageValue,
  setMainImageValue
}) => (
  <div>
    <ImageSelection
      images={images}
      onChange={setImages}
      requiresMain={requiresMainImage}
      setMainImageValue={setMainImageValue}
      mainImageValue={mainImageValue}
    />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/contribution-form/forms/edit-item-form/stage-3/index.js